import { generateApiClient } from '@guiker/rest-client'
import { routes } from '@guiker/websocket-connection-api-definition'

export const ApiClient = generateApiClient('websocket-connection-api', routes)
